import { AuthService } from '@qdrant/qdrant-cloud-public-api/auth/v1/auth';
import {
  listManagementKeys,
  deleteManagementKey,
  createManagementKey,
} from '@qdrant/qdrant-cloud-public-api/auth/v1/auth/connect-query';
import { transport } from '@/api/transport';
import {
  type MutationFactory,
  queryOptions,
  useMutation,
  createServiceQueries,
  createConnectQueryKey,
} from '@/connect-query';

export const authService = createServiceQueries(AuthService, {
  listManagementKeysQuery: (params: { accountId: string }) => queryOptions(listManagementKeys, params, { transport }),
});

export const useDeleteManagementKeyMutation: MutationFactory<typeof deleteManagementKey> = () =>
  useMutation(deleteManagementKey, {
    onSuccess: (_data, { accountId }, _onMutateResult, { client }) =>
      client.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: listManagementKeys,
          input: { accountId },
        }),
      }),
  });

export const useCreateManagementKeyMutation: MutationFactory<typeof createManagementKey> = () =>
  useMutation(createManagementKey, {
    onSuccess: (_data, { managementKey: { accountId } }, _onMutateResult, { client }) =>
      client.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: listManagementKeys,
          input: { accountId },
        }),
      }),
  });
